import { useEffect, useState } from "react";
import SlideOver from "@components/ui/SlideOver";
import Button from "@components/ui/Button";
import Input from "@components/ui/Input";
import Textarea from "@components/ui/Textarea";
import AssertionEditor from "./AssertionEditor";

const blank = { name: "", persona_prompt: "", first_message: "", max_turns: 12, is_active: true, expected_outcome: [] };

export default function ScenarioEditorDrawer({ open, onClose, scenario, onSave }) {
  const [form, setForm] = useState(blank);
  const isBaseline = scenario?.origin === "baseline";

  useEffect(() => {
    setForm(scenario ? {
      name: scenario.name || "",
      persona_prompt: scenario.persona_prompt || "",
      first_message: scenario.first_message || "",
      max_turns: scenario.max_turns ?? 12,
      is_active: scenario.is_active ?? true,
      expected_outcome: scenario.expected_outcome || [],
    } : blank);
  }, [scenario, open]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const footer = (
    <div className="flex justify-end gap-2">
      <Button color="light" onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={() => onSave(form)}>Save</Button>
    </div>
  );

  return (
    <SlideOver open={open} onClose={onClose} title={scenario ? "Edit scenario" : "New scenario"} footer={footer}>
      <div className="space-y-4">
        {isBaseline && (
          <div className="text-sm bg-amber-50 text-amber-700 px-3 py-2 rounded">
            Saving forks this into a custom copy (the baseline is deactivated).
          </div>
        )}
        <Input label="Name" value={form.name} disabled={isBaseline}
          onChange={(e) => set("name", e.target.value)} aria-label="name" />
        <Textarea label="Persona prompt" rows={4} value={form.persona_prompt}
          onChange={(e) => set("persona_prompt", e.target.value)} aria-label="persona" />
        <Textarea label="First message (optional)" rows={2} value={form.first_message}
          onChange={(e) => set("first_message", e.target.value)} />
        <div>
          <Input label="Max turns" type="number" min={1} value={form.max_turns}
            onChange={(e) => set("max_turns", Number(e.target.value))} />
          <p className="text-xs text-gray-500 mt-1">
            Maximum back-and-forth messages the simulated caller and agent exchange
            before the test stops. Too low and the agent may run out of turns before
            collecting everything (a false failure); 10–12 is a good default.
          </p>
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={form.is_active} onChange={(e) => set("is_active", e.target.checked)} />
          Active
        </label>
        <div>
          <div className="text-sm font-medium mb-1">Assertions (expected outcome)</div>
          <AssertionEditor value={form.expected_outcome} onChange={(v) => set("expected_outcome", v)} />
        </div>
      </div>
    </SlideOver>
  );
}
